// extracted by mini-css-extract-plugin
export var author = "helping-hands-preview-module--author--f392c";
export var category = "helping-hands-preview-module--category--e0ed2";
export var content = "helping-hands-preview-module--content--07292";
export var headline = "helping-hands-preview-module--headline--6b033";
export var headlinePost = "helping-hands-preview-module--headline-post--88bbe";
export var image = "helping-hands-preview-module--image--3f4f0";
export var link = "helping-hands-preview-module--link--b0a8f";
export var paragraph = "helping-hands-preview-module--paragraph--373a7";
export var post = "helping-hands-preview-module--post--bb6b8";